import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  commonPostPutFormData,
  fetchApiData,
} from "../../../redux/reducers/commonApiSlice";
import { applyNewLeave, updateAppliedLeave } from "../../../data/ApiEndpoints";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import SelectDropdown from "../../components-react/SelectDropdown";
import { fetchLeaveCategoriesData } from "../../../redux/reducers/apiSlice";
import MultiSelectDate from "../../components-react/MultiSelectDate";
import moment from "moment";

const StaffLeaveForm = ({
  userInfoData,
  closeModal,
  callFunction,
  rowData,
  isEdit,
}) => {
  const dispatch = useDispatch();
  const { data, postPutLoadingFormData } = useSelector((state) => state.common);
  const { leaveCategories } = useSelector((state) => state.api);

  const iniFormValues = {
    leaveDays: 0,
    leaveType: rowData?.leave_category_id
      ? {
          label: rowData?.leave_category_name,
          value: rowData.leave_category_id,
        }
      : "",
    description: rowData?.description ? rowData?.description : "",
    docFile: rowData?.required_doc ? rowData.required_doc : "",
    selectedDates: [],
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [dates, setDates] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const iniInfo = {
    allLeaveCats: [],
    salaryDeduct: {},
  };
  const [allInfo, setAllInfo] = useState(iniInfo);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    // if (type === "file") {
    //   const reader = new FileReader();
    //   reader.readAsDataURL(file);
    //   reader.onload = () => {
    //     const base64File = reader.result;
    //     setFormValues((prevs) => ({
    //       ...prevs,
    //       [name]: type === "checkbox" ? checked : base64File || value,
    //     }));
    //   };
    // } else {
    //   setFormValues((prevs) => ({
    //     ...prevs,
    //     [name]: type === "checkbox" ? checked : type === "file" ? file : value,
    //   }));
    // }
    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : type === "file" ? file : value,
    }));
    setIsSubmit(false);
  };

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (value) => {
    setDates(value);
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validateFormValues(formValues));
    setIsSubmit(true);
  };

  const validateFormValues = (formValues) => {
    let errors = {};

    const isOnlyDocUpload =
      rowData?.leave_dates_with_status?.length > 0
        ? rowData.leave_dates_with_status.some(
            (leave) => leave?.approval_status === 1
          )
        : false;

    // if (!formValues.startDate) {
    //   errors.startDate = "required!";
    // }

    if (formValues.selectedDates?.length === 0) {
      errors.selectedDates = "required!";
    }

    if (!formValues.description) {
      errors.description = "required!";
    }

    if (!formValues.leaveType) {
      errors.leaveType = "required!";
    }

    if (isOnlyDocUpload && !formValues.docFile) {
      errors.docFile = "required!";
    }

    return errors;
  };

  function getAllLeaveCategories() {
    dispatch(
      fetchLeaveCategoriesData({
        filters: {},
        token: userInfoData?.token,
      })
    );
  }

  function getData(endpoint, queryParams) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: endpoint,
        payload: {
          filters: queryParams,
        },
        token: userInfoData?.token,
      })
    );
  }

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? updateAppliedLeave : applyNewLeave;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setIsSubmit(false);
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      leaveType: rowData?.leave_category_id
        ? {
            label: rowData?.leave_category_name,
            value: rowData.leave_category_id,
          }
        : "",
      description: rowData?.description ? rowData?.description : "",
      docFile: rowData?.required_doc ? rowData.required_doc : "",
    }));
  }, [rowData]);

  useEffect(() => {
    getAllLeaveCategories();
  }, []);

  useEffect(() => {
    if (dates?.length > 0) {
      const updatedDates = dates.map((date) => {
        const matchingRow = rowData?.leave_dates_with_status.find((row) =>
          moment(row.leave_date, "YYYY-MM-DD").tz("Asia/Kolkata").isSame(
            moment(date, "DD-MM-YYYY").tz("Asia/Kolkata"),
            "day"
          )
        );
        if (matchingRow) {
          return {
            date: moment(date, "DD-MM-YYYY").tz("Asia/Kolkata").format("YYYY-MM-DD"),
            uid: matchingRow.uid,
          };
        } else {
          return {
            date: moment(date, "DD-MM-YYYY").tz("Asia/Kolkata").format("YYYY-MM-DD"),
          };
        }
      });

      setFormValues((prevs) => ({
        ...prevs,
        leaveDays: dates.length,
        selectedDates: isEdit ? updatedDates : dates,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        leaveDays: 0,
        selectedDates: [],
      }));
    }
  }, [dates, isEdit, rowData?.leave_dates_with_status, setFormValues]);

  // useEffect(() => {
  //   if (dates?.length > 0) {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       leaveDays: dates.length,
  //       selectedDates: dates,
  //     }));
  //   } else {
  //     setFormValues((prevs) => ({
  //       ...prevs,
  //       leaveDays: 0,
  //       selectedDates: [],
  //     }));
  //   }
  // }, [dates]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        gym_id: userInfoData?.gym_id,
        user_id: userInfoData?.user_id || userInfoData?.uid,
        leave_category_id: formValues.leaveType?.value,
        required_doc: formValues.docFile,
        leave_dates: JSON.stringify(formValues.selectedDates),
        description: formValues.description,
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      if (isEdit) {
        formData.append("apply_date", rowData.apply_date);
      }

      handleAdd(formData);
    }
  }, [isSubmit, formErrors]);

  useEffect(() => {
    if (leaveCategories?.status && leaveCategories?.data) {
      const allLeaves = leaveCategories.data?.map((item) => ({
        value: item.uid,
        label: item.name,
        info: item,
      }));
      setAllInfo((prevs) => ({
        ...prevs,
        allLeaveCats: allLeaves,
      }));
    } else {
      setAllInfo((prevs) => ({
        ...prevs,
        allLeaveCats: [],
      }));
    }
  }, [leaveCategories]);

  useEffect(() => {
    if (data?.status && data?.data) {
      setAllInfo((prevs) => ({
        ...prevs,
        salaryDeduct: data.data,
      }));
    } else {
      setAllInfo((prevs) => ({
        ...prevs,
        salaryDeduct: {},
      }));
    }
  }, [data]);

  // console.log("formValues.leaveType=> ", formValues.leaveType);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedDates" className={`formInputLabel `}>
              Leave Dates *
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedDates ? "formError" : ""
              }`}
            >
              <MultiSelectDate
                convertedDates={dates}
                setConvertedDays={setDates}
                onChangeDate={handleDateChange}
                minDate={!isEdit ? new Date() : ""}
                prevDates={
                  rowData?.leave_dates_with_status?.length > 0
                    ? rowData.leave_dates_with_status
                    : []
                }
                isEdit={isEdit}
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="leaveDays" className={`formInputLabel `}>
              No. Of Leave Days
            </label>

            <input
              type="text"
              className="formInput"
              name="leaveDays"
              placeholder={`🚫 ${formValues.leaveDays || 0}`}
              disabled
            />
          </div>

          <div className="formInputBox withInfo">
            <label htmlFor="leaveType" className="formInputLabel">
              Leave Type *
            </label>

            <div
              className={`commonWrapper ${
                formErrors.leaveType ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={allInfo.allLeaveCats}
                selectedOption={formValues.leaveType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("leaveType", selectedValue)
                }
                name="Leave Type"
                isDisable={
                  isEdit && rowData?.leave_dates_with_status?.length > 0
                    ? rowData?.leave_dates_with_status.some(
                        (leave) => leave?.approval_status === 1
                      )
                    : false
                }
              />
            </div>

            {formValues.leaveType && (formValues.leaveType.info || isEdit) ? (
              <>
                <span className="info">
                  {(formValues.leaveType?.info &&
                    formValues.leaveType?.info?.is_paid) ||
                  (isEdit && rowData?.is_paid)
                    ? "Paid Leave"
                    : "Unpaid Leave"}
                </span>

                {(formValues.leaveType?.info &&
                  formValues.leaveType?.info?.approval_required) ||
                (isEdit && rowData?.approval_required) ? (
                  <span className="info">Approval Required!</span>
                ) : null}

                {(formValues.leaveType?.info?.no_ofdays &&
                  formValues.leaveType?.info?.no_ofdays !== "0") ||
                (isEdit && rowData && rowData?.no_ofdays) ? (
                  <span className="info">
                    Max {formValues.leaveType?.info?.no_ofdays} Day(S) Leave Can
                    Be Approved!
                  </span>
                ) : null}

                {(formValues.leaveType?.info?.days_before &&
                  formValues.leaveType?.info?.days_before !== "0") ||
                (isEdit && rowData?.days_before) ? (
                  <span className="info">
                    This Leave Needs To Be Applied Min{" "}
                    {formValues.leaveType?.info?.days_before} Day(S) Before To
                    Get Approved!
                  </span>
                ) : null}

                {/* {(formValues.leaveType?.info &&
                  formValues.leaveType?.info?.no_ofdays &&
                  formValues.leaveType?.info?.no_ofdays !== "0") ||
                (isEdit && rowData?.no_ofdays) ? (
                  <span className="info">
                    Max {formValues.leaveType.info.no_ofdays} Day(S) Leave Can
                    Be Approved!
                  </span>
                ) : null} */}

                {/* {(formValues.leaveType?.info &&
                  formValues.leaveType?.info?.days_before &&
                  formValues.leaveType?.info?.days_before !== "0") ||
                (isEdit && rowData?.days_before) ? (
                  <span className="info">
                    This Leave Need To Be Apply Min{" "}
                    {formValues.leaveType.info.days_before} Day(S) Before To Get
                    Approved!
                  </span>
                ) : null} */}

                {(formValues.leaveType?.info &&
                  formValues.leaveType?.info?.doc_required) ||
                (isEdit && rowData?.required_doc) ? (
                  <span className="info">
                    Document Required!
                    <br />
                    (You Can Upload The Document After Applying This Leave)
                  </span>
                ) : null}
              </>
            ) : null}
          </div>
        </div>

        <div className={`commonWrapper commonSwitchWrapper mt30`}>
          <div className="formInputBox textareaFormInputGrid">
            <label htmlFor="description" className="formInputLabel">
              Description *
            </label>

            <textarea
              name="description"
              className={`formInput ${
                formErrors.description ? "formError" : ""
              }`}
              placeholder="Brief Why You Are Applying For This Leave"
              value={formValues.description}
              onChange={onChangeInput}
              disabled={
                isEdit && rowData?.leave_dates_with_status?.length > 0
                  ? rowData?.leave_dates_with_status.some(
                      (leave) => leave?.approval_status === 1
                    )
                  : false
              }
            ></textarea>
          </div>

          <div className="formInputBox textareaFormInputGrid">
            <label htmlFor="description" className="formInputLabel">
              Document
            </label>
            <div
              className={`input-group file-upload-input ${
                formErrors?.docFile ? "formError" : ""
              }`}
            >
              <div className="custom-file">
                <div className="choosefileBtn">
                  <input
                    type="file"
                    className="custom-file-input"
                    id="docFile"
                    name="docFile"
                    aria-describedby="inputGroupFileAddon01"
                    file={formValues.docFile}
                    onChange={onChangeInput}
                  />
                </div>
                <label className="custom-file-label" htmlFor="docFile">
                  Upload Document
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
            {postPutLoadingFormData ? <ReactVortoxSpinner /> : "Submit"}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default StaffLeaveForm;
